import React from "react";
import { useSelector } from "react-redux";
import { toNumber } from "lodash";
import { RootState } from "../../redux-stores/store";
import { selectAllCampaigns } from "../../redux-stores/selectors/campaignSelectors";
import SponsorshipCampaignCard from "./SponsorshipCampaignCard";
import { getCategory } from "./sponsorshipCampaignShared";
import SponsorshipSectionSkeleton from "../../skeletons/SponsorshipSectionSkeleton";
import "./style.scss";

const AllCampaigns: React.FC = () => {
    const campaigns = useSelector(selectAllCampaigns);
    const loading = useSelector((state: RootState) => state.campaigns.loading);

    if (loading && campaigns.length === 0) {
        return <SponsorshipSectionSkeleton cardCount={2} />;
    }

    if (campaigns.length === 0) return null;

    return (
        <section className="best-of-influns">
            <div className="best-of-influns-divider" aria-hidden>
                <svg width="84" height="14" viewBox="0 0 84 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line y1="6.75009" x2="30" y2="6.75009" stroke="#737373" strokeWidth="0.5" />
                    <path
                        d="M47.1899 7.4876C44.8965 8.1051 43.1051 9.89652 42.4876 12.1899L42.0002 14.0002L41.5128 12.1899C40.8951 9.89652 39.1037 8.1051 36.8103 7.4876L35 7.0002L36.8103 6.5128C39.1037 5.8951 40.8951 4.10367 41.5126 1.81033L42 0L42.4874 1.81033C43.1049 4.10367 44.8963 5.8951 47.1897 6.5126L49 7L47.1899 7.4876Z"
                        fill="#737373"
                    />
                    <line x1="54" y1="6.75009" x2="84" y2="6.75009" stroke="#737373" strokeWidth="0.5" />
                </svg>
            </div>

            <div className="best-of-influns-title">
                <p className="best-of-influns-eyebrow">EXPLORE</p>
                <p className="best-of-influns-heading">The Best of Influns</p>
            </div>
            <div className="best-of-influns-gradient"></div>
            {/* <div className="best-of-influns-chips" aria-label="Filters">
                <button type="button" className="best-of-influns-chip best-of-influns-chip--primary">
                    Filters
                </button>
                <button type="button" className="best-of-influns-chip">
                    Cosmetics
                </button>
                <button type="button" className="best-of-influns-chip">
                    Fitness
                </button>
            </div> */}

            <div className="best-of-influns-list px-3">
                {campaigns.map((campaign) => {
                    const budget = toNumber(campaign?.budget);
                    const footerAmount = budget > 0 ? budget : toNumber((campaign as any)?.barter_budget);
                    return (
                        <SponsorshipCampaignCard
                            key={campaign.uuid}
                            campaign={campaign}
                            className="sponsorship-card--wide"
                            proBadge={!!campaign.is_pro}
                        />
                    );
                })}
            </div>
        </section>
    );
};

export default AllCampaigns;

